import { supportedDocuments } from "./supportedDocuments";

const en = {
  notFound: "Supplier not found",
  notFoundctx:
    "Please use the link provided to you via email. In case you still see this message please contact us at",
  supplierDeleted: "Supplier deleted. Check link or authorizations.",
  supplier_portal_tag_line: `Collect and process your invoices automatically ensuring error-free execution`,
  step1: "Step 1. Select",
  step1ctx: "Select invoices from your files.",
  step2: "Step 2. Check",
  step2ctx: "Check if the correct invoices were selected.",
  step3: "Step 3. Upload",
  step3ctx: "Upload the invoices selected.",
  login: "Login",
  drop: "Drop or select documents.",
  dropctx1: "Drop documents from your computer",
  dropctx2: "or browse",
  dropctx3: "to select",
  selected: "Selected documents:",
  removeAll: "Remove All",
  upload: "Upload documents",
  duplicateNotAllowed: "Duplicate files are not allowed",
  limit: "Limit of 10 documents.",
  successUpload: "Document(s) uploaded successfully",
  errorUpload: "Error uploading documents: ",
  useDedicatedLink:
    "You cannot upload without using your dedicated url. Please use the link we have sent you through email.",
  logout: "Logout",
  onboardingV2: {
    step_of: "Step {{current}} of {{total}}",
    basic_title: "Start with the basics",
    basic_text: "Five short steps. You can save and come back at any time.",
    bank_title: "Where should we pay you?",
    bank_text:
      "Payment details are encrypted and only visible to finance approvers.",
    address_title: "Your addresses",
    address_text: "Used on purchase orders and delivery notes.",
    legal_title: "Who signs for the company?",
    legal_text: "Signatory and identity documents",
    documents_title: "Add your documents",
    documents_text:
      "We check these before your first invoice can be processed.",
    dni_documents: "Front and Back of DNI Card",
    card_basic_title: "Basic Information",
    card_basic_subtitle: "Provide your essential details",
    card_bank_title: "Bank Information",
    card_bank_subtitle: "Where we send payment for approved invoices.",
    card_address_title: "Address Information",
    card_address_subtitle:
      "Registered address used on purchase orders and invoices.",
    card_legal_title: "Legal Representative",
    card_legal_subtitle:
      "The person authorized to sign on behalf of the company.",
    card_documents_title: "Documents",
    card_documents_subtitle:
      "Give every file a name and an expiry date so we can remind you before it lapses.",
    save_later: "Save & continue later",
    mandatory: "Mandatory",
    save: "Save",
    save_progress_title: "Save your progress",
    save_progress_text:
      "You can re-login later to finish the remaining onboarding later",
    progress_saved: "Progress saved",
    reset_reason: "Onboarding Reset Reason",
    mandatory_error:
      "Kindly provide missing mandatory information to proceed further",
    profile_update_may_reset_onboarding:
      "If you update any information here, your onboarding might get reset",
    confirm_update_title: "Confirm update",
  },
  email: {
    enterEmail: "Enter your email to receive a confirmation code",
    enterEmailCtx:
      "This will help us make us sure it's you before allowing uploads",
    emailAddress: "Email Address",
    sendCode: "Send Code",
    verify: "Verify",
    checkEmail: "Enter your verification code",
    checkEmailCtx1: "We have sent a 6-digit confirmation code to",
    checkEmailCtx2: ". Please enter the code below to verify your email.",
    confirm: "Confirm",
    code: "Code",
    resend: "Didn't receive it?",
    resendLink: "Resend Code",
    codeResent: "Code was resent to your email",
    wrongCode: "Wrong code entered",
  },
  loadingSupplier: "Loading supplier...",
  NeedReview: "Need review",
  Default: "In progress",
  Extracted: "Processed",
  Failed: "Failed",
  Error: "Error",
  Reviewed: "Reviewed",
  Duplicate: "Duplicate",
  "Add Document": "Add Document",
  "Created on": "Created on",
  Status: "Status",
  Date: "Date",
  Message: "Message",
  Close: "Close",
  "Document name": "Document name",
  Paid: "Paid",
  UnPaid: "Unpaid",
  Approved: "Approved",
  Rejected: "Rejected",
  "Payment status": "Payment status",
  "ERP status": "ERP status",
  All: "All",
  Documents: "Documents",
  documents: "Documents",
  "Erp status": "Erp status",
  Actions: "Actions",
  "Created in ERP": "Created in ERP",
  Yes: "Yes",
  No: "No",
  Pending: "Pending",
  "View ERP details": "View ERP details",
  "ERP Details": `ERP Details`,
  "View payment details": "View payment details",
  "Payment Details": "Payment Details",
  "Payment Date": "Payment Date",
  "Transaction method": "Transaction method",
  "Rows per page": "Rows per page",
  of: "of",
  upload_by_device: "Upload by device",
  a_maximum_of_10_files_are_allowed_in_a_single_upload: `A maximum of 10 files are allowed in a single upload`,
  select_language: "Select language",
  no_data: `No Data`,
  supplier: `Supplier`,
  add_a_new_document: `Add a new Document`,
  entries_per_page: `Entries per page`,
  "Drop your files here or browse through your machine.": `Drop your files here or browse through your machine.`,
  browse: `Browse`,
  upload_documents: `Upload Documents`,
  upload_from_device: `Upload from device`,
  deliveryNote: `Delivery note`,
  invoice: `Invoice`,
  // Create Document
  add_valid_date: `Add valid date`,
  totalAmount: `Total amount`,
  customerCompanyName: `Supplier company name`,
  customerCompanyID: `Supplier company ID`,
  customerCompanyAddress: `Supplier company address`,
  customerEmail: `Supplier email`,
  customerCompanyName_is_required: `Customer company name is required`,
  customerCompanyID_is_required: `Customer company ID is required`,
  customerCompanyAddress_is_required: `Customer company address is required`,
  customerEmail_is_required: `Customer Email is required`,
  create_document: `Create Document`,
  account_information: `Account information`,
  document_information: `Document information`,
  customer_information: `Customer information`,
  vendor_information: `My information`,
  items_information: `Items information`,
  taxes_information: `Taxes information`,
  account_class: `Account class`,
  document_class: `Document class`,
  optional: `Optional`,
  account_receivable: `Account receivable`,
  account_payable: `Account payable`,
  accountClass_is_required: `Account class is required`,
  documentClass_is_required: `Document class is required`,
  back: `Back`,
  next: `Next`,
  invoiceID: `Invoice ID`,
  documentNumber: `Document number`,
  poNumber: `PO number`,
  totalWithoutTax: `Total (without tax)`,
  totalTax: `Total tax`,
  taxPercentage: `Tax percentage`,
  documentDate: `Document date`,
  dueDate: `Due date`,
  invoiceId_is_required: `Invoice Id is required`,
  documentNumber_is_required: `Document number is required`,
  poNumber_is_required: `PO number is required`,
  totalWithoutTax_is_required: `Total without tax is required`,
  totalTax_is_required: `Total tax is required`,
  totalAmount_is_required: `Total amount is required`,
  taxPercentage_is_required: `Tax percentage is required`,
  deliveryNote_is_required: `Delivery note is required`,
  documentDate_is_required: `Document date is required`,
  dueDate_is_required: `Due date is required`,
  vendorCompanyName: `Company name`,
  vendorCompanyID: `Company ID`,
  vendorCompanyAddress: `Company address`,
  vendorCompanyName_is_required: `Company name is required`,
  vendorCompanyID_is_required: `Company ID is required`,
  vendorCompanyAddress_is_required: `Company address is required`,
  referenceCode: `Reference code`,
  unit: `Unit`,
  unitPrice: `Unit price`,
  vatPercentage: `VAT %`,
  vat: `VAT`,
  dtoPercentage: `DTO %`,
  dto: `DTO`,
  discountPercentage: `Discount %`,
  discount: `Discount`,
  subTotalAmount: `Subtotal amount`,
  referenceCode_is_required: `Reference code is required`,
  description_is_required: `Description is required`,
  unit_is_required: `Unit is required`,
  unitPrice_is_required: `Unit price is required`,
  quantity_is_required: `Quantity is required`,
  vatPercentage_is_required: `VAT percentage is required`,
  vat_is_required: ` VAT is required`,
  dtoPercentage_is_required: `DTO percentage is required`,
  dto_is_required: `DTO is required`,
  discountPercentage_is_required: ` Discount percentage is required`,
  discount_is_required: `Discount is required`,
  subTotalAmount_is_required: `Sub total amount is required`,
  amount_is_required: `Amount is required`,
  delete_item: `Delete item`,
  update_item: `Update item`,
  delete_items: `Delete items`,
  taxes: `Taxes`,
  baseAmount: `Base amount`,
  add_tax: `Add tax`,
  submit: `Submit`,
  reset: `Reset`,
  atleast_one_item_is_required: `Atleast one item is required`,
  atleast_one_tax_is_required: `Atleast one tax is required`,
  submit_and_create_new_document: `Submit and create new document`,
  baseAmount_is_required: `Base amount is required`,
  vendorEmailAddress: `Email address`,
  vendorEmail_is_required: `Email address is required`,
  add_item: `Add item`,
  delete_approval: `Are you sure you want to delete this`,
  upload_document: `Upload document`,
  document_is_required: `Document is required`,
  email_invalid: `Email must be a valid email address`,
  quantity: `Quantity`,
  amount: `Amount`,
  actions: `Actions`,
  description: `Description`,
  cancel_button: `Cancel`,
  delete: `Delete`,
  tax: `Tax`,
  delete_tax: `Delete tax`,
  delete_taxes: `Delete taxes`,
  only_one_document_is_allowed_to_upload: `Only one document allowed to be upload`,
  document_created_successfully: `Document created successfully`,
  update_tax: `Update tax`,
  my_information: `My information`,
  emailAddress: `Email address`,
  companyAddress: `Company address`,
  companyID: `Company ID`,
  companyName: `Company name`,
  companyName_is_required: `Company name is required`,
  companyID_is_required: `Company ID is required`,
  companyAddress_is_required: `Company address is required`,
  email_is_required: `Email address is required`,
  dueDate_should_be_greater_than_documentDate: `Due date should be greater than document date`,
  documentDate_should_be_less_than_dueDate: `Document date should be less than due date`,
  "tax_amount_not_%": "Tax (amount)",
  document_details: `Document Details`,
  date_details: `Date Details`,
  logo_url: `Logo URL`,
  please_enter_your_information: `Please enter your information`,
  please_enter_customer_information: `Please enter information of your customer who will receive this document.`,
  "Approval Process": `Approval process`,
  tax_must_be_number: `Tax is required and must be number`,
  discount_must_be_number: `Discount must be number`,
  unitPrice_must_be_number: `Unit price is required and must be number`,
  quantity_must_be_number: `Quantity is required and must be number`,
  baseAmount_must_be_number: `Base amount is required and must be number`,
  tax_is_required: `Tax is required`,
  upload_deliveryNote: `Upload Delivery Note`,
  upload_invoice: `Upload Invoice`,
  finance_screen: {
    email_text: `Your own dedicated email to send the documents`,
    docs_processed: `Processed Documents`,
    email_csv_export: `Email CSV Export`,
    selected_files: `Selected file(s)`,
    remove_all: `Remove all`,
    upload_files: `Upload files`,
    duplicate_files_are_not_allowed: `Duplicate Files are not Allowed`,
    files_cannot_be_more_than_10: `Files cannot be more than 10`,
    document_uploaded_successfully: `Document Uploaded Successfully`,
    extract_now: `Extract now`,
    all: `All`,
    Invoice: `Invoices`,
    PurchaseOrder: `Purchase Orders`,
    credit_memo: `Credit Memo`,
    delivery_note: `Delivery Note`,
    reciepts: `Receipts`,
    processed_on: `Processed on`,
    DeliveryNote: `Delivery Note`,
    Reciepts: `Receipts`,
    filename: `File Name`,
    processed_at: `Processed At`,
    output: `Output`,
    status: `Status`,
    creeated_in_erp: `Created in ERP`,
    no_data: `No data`,
    dense: `Dense`,
    rows_per_page: `Rows per page:`,
    retry_button: `Retry`,
    yes_button: `Yes`,
    no_button: `No`,
    start_date: `Start Date`,
    end_date: `End Date`,
    search: `Search`,
    document_upload_unsuccessful: `Document Upload Failed`,
    "Document not supported": `Document not supported`,
    "Number of pages exceed": "Number of pages exceeded",
    "Limit Exceed": `Document Limit Exceeded`,
    document_name: `Document Name`,
    SimpleNote: `Simple Note`,
    WorkContract: `Work Contract`,
    Payroll: `Payroll`,
    DNI: `DNI`,
    Passport: `Passport`,
    NIE: `NIE`,
    SimulatedInvoice: `Simulated Invoice`,
    output_data: `Output data`,
    CreditNote: `Credit Note`,
    failed_to_fetch_document_version_id: `Failed to fetch Document Version ID`,
  },
  status: {
    in_process: `In process`,
    processed: `Processed`,
    failed: `Failed`,
    error: `Error`,
    need_review: `Need Review`,
    reviewed: `Reviewed`,
    duplicate: `Duplicate`,
    connected: `Connected`,
    not_connected: `Not connected`,
    success: `Success`,
    plan: `free`,
    "My rofile": `My profile`,
    Logout: `Logout`,
    "Email must be a valid email address": `Email must be a valid email address`,
    "Email is required": `Email is required`,
    "Name is required": `Name is required`,
    registration_number_required: `Registration number is required`,
    registration_number_validation2: `Registration number is invalid`,
    registration_number_validation1: `Registration number cannot be more than 20 characters`,
    iban_validation_2: `IBAN is invalid`,
    iban_validation_1: `IBAN cannot be more than 24 characters`,
    "My Profile": `My Profile`,
    name: `Name`,
    Email: `Email`,
    registration_number: `Registration Number`,
    account_holder_name: `Account holder name`,
    iban: `IBAN`,
    "Go back": `Go back`,
    Save: `Save`,
    Invoice: `Invoice`,
    PurchaseOrder: `Purchase Order`,
    DeliveryNote: `Delivery Note`,
  },
  Filters: `Filters`,
  "Document status": `Document status`,
  "Approval status": `Approval status`,
  "ERP integrated": `ERP integrated`,
  "Include deleted documents": `Include deleted documents`,
  "Clear all": `Clear all`,
  "Search ...": `Search ...`,
  "Create Purchase order": `Create Purchase order`,
  account_holder_name: `Account holder name`,
  registration_number: `Registration Number`,
  name: `Name`,
  Email: `Email`,
  iban: `IBAN`,
  "Upload purchase order": `Upload purchase order`,
  "Upload Purchase Order": `Upload Purchase Order`,
  "Delete document": `Delete document`,
  "Are you sure you want to delete this document?": `Are you sure you want to delete this document?`,
  "Are you sure you want to delete all documents?": `Are you sure you want to delete all documents?`,
  "Are you sure you want to delete these documents?": `Are you sure you want to delete these documents?`,
  PurchaseOrder: `Purchase Order`,
  Invoice: `Invoice`,
  CreditNote: `Credit Note`,
  DebitNote: `Debit Note`,
  DeliveryNote: `Delivery Note`,
  ERPPurchaseOrder: `ERP Purchase Order`,
  "IBAN cannot be more than 24 characters": `IBAN cannot be more than 24 characters`,
  "IBAN is required": `IBAN is required`,
  "IBAN is not valid": `IBAN is not valid`,
  account_holder_name_required: `Account holder name is required`,
  registration_number_required: `Registration number is required`,
  registration_number_validation1: `Registration number cannot be more than 20 characters`,
  registration_number_validation2: `Registration number is invalid`,
  NeedApproval: `Approval required`,
  Onboarding: `Onboarding`,
  "Complete Your Profile": `Complete Your Profile`,
  "You're almost done! Complete any missing information to finish your setup.": `You're almost done! Complete any missing information to finish your setup.`,
  "Bank Details": `Bank Details`,
  "Verify Your Bank Details": `Verify Your Bank Details`,
  "Review your bank information and fill in any gaps for smooth transactions.": `Review your bank information and fill in any gaps for smooth transactions.`,
  Profile: `Profile`,
  "Supplier Updated": `Supplier Updated`,
  deleted_document: "Document deleted",
  something_went_wrong: "Something went wrong",
  unauthorized: "Unauthorized",
  supplier_has_pending_workflow:
    "This supplier has a pending workflow. Please wait until it is completed before uploading documents.",
  supplier_suspended:
    "This supplier is suspended. Document upload is not allowed.",
  "Company ID": "Company ID",
  "Onboarding completed": "Onboarding completed",
  supplier_profile_under_review_with_reason: `Your supplier profile has been submitted and is currently under review due to {{reason}}. We will notify you once it is approved.`,
  supplier_profile_under_review: `Your supplier profile has been submitted and is currently under review. We will notify you once it is approved.`,
  approval_pending: `Approval pending`,
  Finish: "Finish",
  Continue: "Continue",
  Back: "Back",
  "Email must be a valid email address": "Email must be a valid email address",
  "Email is required": "Email is required",
  "Name is required": "Name is required",
  "Nationality is required": "Nationality is required",
  "Tax Identification Number is required":
    "Tax Identification Number is required",
  "Registered address is required": "Registered address is required",
  "Company Description is required": "Company Description is required",
  "Power Attorney is required": "Power Attorney is required",
  "Full Name is required": "Full Name is required",
  "Document is required": "Document is required",
  "Address is required": "Address is required",
  "Bank Account Ownership is required": "Bank Account Ownership is required",
  "Compliance With Social Security is required":
    "Compliance With Social Security is required",
  "Compliance With Tax Administration is required":
    "Compliance With Tax Administration is required",
  "Last Month Payment Intallment Of Civil Liability Insurance Policy is required":
    "Last Month Payment Installment Of Civil Liability Insurance Policy is required",
  "Goods and Services is required": "Goods and Services is required",
  "Acceptance of Terms and Conditions is required":
    "Acceptance of Terms and Conditions is required",
  "Supported Documents": "Supported Documents",
  "Terms & Conditions": "Terms & Conditions",
  "Legal Entity": "Legal Entity",
  "Company name": "Company name",
  Nationality: "Nationality",
  "Tax Identification Number (NIF)": "Tax Identification Number (NIF)",
  "Email address": "Email address",
  "Registered address": "Registered address",
  "Description of the Company’s Activity (corporate purpose)":
    "Description of the Company’s Activity (corporate purpose)",
  "Legal Representative": "Legal Representative",
  "Power of Attorney": "Power of Attorney",
  "ID/NIE/Passport/equivalent document": "ID/NIE/Passport/equivalent document",
  Individual: "Individual",
  "Full Name": "Full Name",
  Address: "Address",
  "Certificate of Bank Account Ownership.":
    "Certificate of Bank Account Ownership.",
  "Certificate of Compliance with Social Security":
    "Certificate of Compliance with Social Security",
  "Certificate of Compliance with the Tax Administration.":
    "Certificate of Compliance with the Tax Administration.",
  "Certificate of Payment for the Last Monthly Installment of the Civil Liability Insurance Policy":
    "Certificate of Payment for the Last Monthly Installment of the Civil Liability Insurance Policy",
  "Goods / Services": "Goods / Services",
  "By checking this box, I confirm that I have read, understood, and agree to the":
    "By checking this box, I confirm that I have read, understood, and agree to the",
  "Terms and Conditions": "Terms and Conditions",
  ", including compliance with all applicable regulations and guidelines.":
    ", including compliance with all applicable regulations and guidelines.",

  "Other conditions": "Other conditions",
  View: "View",
  "An unexpected error has occured": "An unexpected error has occured",
  "Profile updated": "Profile updated",
  "An error has occured": "An error has occured",
  "View document": `View document`,
  "Impersonate Supplier Sign In": "Impersonate Supplier Sign In",
  impersonate_token_invalid:
    "This impersonation link has expired or already been used",
  // Onboarding
  currency: `Currency`,
  address: `Address`,
  currency_is_required: `Currency is required`,
  address_is_required: `Address is required`,
  // Cardonar document list
  POSTED: "Posted",
  PENDING_POSTING: "Pending posting",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  NOT_EXIST: "Not Exist",
  PENDING: "Pending",
  PAID: "Paid",
  UNPAID: "Unpaid",
  PENDING_PAYMENT: "Pending payment",
  Code: "Code",
  "Expected Payment Date": "Expected Payment Date",
  "Payment Info": "Payment Info",
  // Transactions
  queries: `Queries`,
  answer_query: `Answer query`,
  send_answer: `Send answer`,
  answer: `Answer`,
  question: `Question`,
  raised_by: `Raised by`,
  raised_on: `Raised on`,
  entity_type: `Entity type`,
  query_status_pending: `Pending`,
  query_status_answered: `Answered`,
  query_status_closed: `Closed`,
  query_answered_successfully: `Query answered successfully`,
  transactions: `Transactions`,
  transaction_date: `Transaction date`,
  customer_name: `Customer name`,
  view_invoices: `View invoices`,
  transaction_details: `Transaction details`,
  transacted_on: `Transacted on`,
  invoices: `Invoices`,
  paid_amount: `Paid amount`,
  total_amount: `Total amount`,
  payment_details: `Payment details`,
  created_on: `Created on`,
  vendor_name: `Vendor Name`,
  invoice_payments: `Invoice Payments`,
  Due: `Due`,
  Process: `Process`,
  PartialPaid: `Partial Paid`,
  transaction_id: `Transaction ID`,
  created_by: `Created by`,

  // Permissions
  access_forbidden: `Access forbidden`,
  you_dont_have_permission_to_access_this_page: `You don't have permission to access this page`,
  go_to_homepage: `Go to homepage`,
  page_not_found: `Page not found`,
  "The page you are looking for might have been removed or its name changed or is temporarily unavailable.":
    "The page you are looking for might have been removed or its name changed or is temporarily unavailable.",
  supplier_contract: `Supplier contract`,
  view_contract: `View contract`,
  file_size_exceeds_the_limit: `File size exceeds the limit`,
  failed_to_fetch_supplier_profile: "Failed to fetch supplier profile",
  not_document_owner: `Action denied: You are not the owner of this document.`,
  contract_details: `Contract details`,
  verify_your_contract_details: `Verify your contract details`,
  "Invalid file type. Only PDF, DOCX, JPG, and PNG are allowed.": `Invalid file type. Only PDF, DOCX, JPG, and PNG are allowed.`,
  supplier_contract_cannot_uploaded: `Supplier contract cannot be uploaded`,
  contract_removed_successfully: `Contract removed successfully`,
  remove: `Remove`,
  delete_contract: `Delete contract`,
  delete_contract_warning: `Deleted contract cannot be recovered`,
  tax_type: `Tax type`,
  tax_type_is_required: `Tax type is required`,
  recurring_invoice: `Recurring invoice`,
  "Something went wrong": `Something went wrong`,
  recurring_invoice_information: `Recurring invoice information`,
  IsRecurringGeneratedDocument: `Generate recurring document`,
  invoiceDueInDays: `Invoice due in days`,
  recurringFrequencyType: `Recurring frequency type`,
  startDate_is_required: `Start date is required`,
  endDate_is_required: `End date is required`,
  invoiceDueInDays_is_required: `Invoice due in days is required`,
  recurringFrequencyType_is_required: `Recurring frequency type is required`,
  recurring_source: `Recurring source`,
  recurring_generated: `Recurring generated`,
  delete_and_create_new: `Delete and create new`,
  delete_recurring_document_approval: `Are you sure you want to delete this document and create new?`,
  source_document: `Source document`,
  source_document_id: `Source document ID`,
  "Original document": "Original document",
  RecurringByMinutes: `Recurring by minutes`,
  Yearly: `Yearly`,
  Monthly: `Monthly`,
  Weekly: `Weekly`,
  Daily: `Daily`,
  ExpenseCategory: `Expense Category`,
  TaxType: `Tax Type`,
  taxType: "Tax type",
  taxType_is_required: `Tax Type is required`,
  "tax_%": `Tax %`,
  endDate_should_be_greater_than_startDate: `End date should be greater than start date`,
  companyID_cannot_contain_comma: `Company ID cannot contain comma`,
  Messages: "Messages",
  "See more": "See more",
  "Output data": "Output data",
  "Document Messages": "Document Messages",
  no_: "No.",
  document_date: "Document date",
  vendor_address: "Vendor address",
  vendor_id: "Vendor ID:",
  code: "Code",
  purchase_order: "Purchase order",
  delivery_note: "Delivery Note",
  unit_price: "Unit price",
  subtotal: "Subtotal",
  total_without_tax: "Total (without tax)",
  total_tax: "Total tax",
  total: "Total",
  of_: "of",
  "Create Delivery Note": "Create Delivery Note",
  "Create Invoice": "Create Invoice",
  "Catalog item": "Catalog item",
  WHT: "Withholding Tax",
  VAT: "VAT",
  startDate: "Start date",
  endDate: "End date",
  tax_info_not_required: `Tax information is not required as it is already included in items information. You may, however, specify withholding tax (WHT) if applicable.`,
  daily: `Daily`,
  weekly: `Weekly`,
  monthly: `Monthly`,
  yearly: `Yearly`,
  // Notes
  notes: `Notes`,
  note: `Note`,
  view_notes: `View notes`,
  add: `Add`,
  close: `Close`,
  no_data_found: `No data found`,
  resource_not_found: `Resource not found`,
  add_filter: `Add filter`,
  document_filters: `Document filters`,
  field_name: `Field name`,
  field_value: `Field value`,
  field_value_is_required: `Field value is required`,
  field_name_is_required: `Field name is required`,
  view_details: `View details`,
  delete_note_title: `Delete note`,
  add_a_note: `Add a note`,
  no_notes_found: `No notes found`,
  note_is_required: `Note is required`,
  note_validation_max_length: `Note cannot be more than 1000 characters`,
  notes_length_exceed: `Notes length exceeded`,
  note_deletedBy_deletedOn: `Deleted by {{deletedBy}} on {{deletedOn}}`,
  document_note_not_owner: `You are not the owner of this note and cannot perform this action.`,
  error_parsing_supplier_info: `Error parsing supplier information`,
  document_not_exist: `Document does not exist`,
  general_information: `General information`,
  legal_information: `Legal information`,
  street: `Street`,
  city: `City`,
  county: `County`,
  street_number: `Street number`,
  municipality: `Municipality`,
  postcode: `Postcode`,
  province: `Province`,
  zipCode: `ZIP code`,
  id_card_front_document: `DNI card (Front)`,
  id_card_back_document: `DNI card (Back)`,
  upload_front_id_card: `Upload the front side of your DNI card`,
  upload_back_id_card: `Upload the back side of your DNI card`,
  first_name: `First name`,
  last_name: `Last name`,
  basic_info: `Basic information`,
  companies: `Customer Companies`,
  address_info: `Address information`,
  additional_documents: `Additional documents`,
  zip_code: `ZIP code`,
  fax_number: `Fax number`,
  contact_number: `Contact number`,
  "Complete your address and contact details.": `Complete your address and contact details.`,
  document_type: `Document type`,
  document_code: `Document code`,
  number: `Number`,
  country: `Country`,
  legal_representative_details: `Legal representative details`,
  verify_your_legal_representative_details: `Verify your legal representative details`,
  legal_representative_information: `Legal representative information`,
  total_discount: `Total discount`,
  dni_number: `DNI number`,
  other_details: `Other details`,
  transaction_detail: `Transaction detail`,
  consenturl: `Consent URL`,
  transactionStatus: `Status`,
  legal_documents: `Legal documents`,
  project_number: `Project number`,
  document: `Document`,
  signed_contract: `Signed contract`,
  add_document: `Add document`,
  current_payment: `Current payment`,
  no_documents_found: `No documents found`,
  project_number_is_required: `Project number is required`,
  document_type_is_required: `Document type is required`,
  "Review Your legal documents": `Review your legal documents`,
  "Check the details of your uploaded documents.": `Check the details of your uploaded documents.`,
  email_address: `Email address`,
  preview_file: `Preview file`,
  only_one_file_is_allowed_to_upload: `Only one file is allowed to upload`,
  signature: `Signature`,
  companyid_must_be_unique: `Company Id must be unique`,
  discounts_information: `Discounts information`,
  total_after_discount: `Total after discount`,
  total_before_discount: `Total before discount`,
  "attach_support_document_(optional)": `Attach support document (Optional)`,
  comments: `Comments`,
  field_name_cannot_exceed_characters: `{{fieldName}} cannot exceed {{number}} characters.`,
  approval_accepted: `Approval accepted`,
  approval_rejected: `Approval rejected`,
  approval_rejected_reason: `Rejection reason`,
  reason: `Reason`,
  obResetReason: `Onboarding Reset Reason`,
  ob_rejection_text: `Your supplier portal request has been rejected. Please contact the client for further details.`,
  view_more: `View more`,
  onboarding: `Onboarding`,
  supplierpayment: {
    supplier_Onboarding_incomplete: "Supplier onboarding is incomplete",
  },

  //Volotea-Form

  volotea_profile: `Volotea Profile`,
  Volotea_Onboarding: `Volotea Onboarding`,

  // Header / Top Section
  triggered_by: `Triggered By`,
  // email_address: `Email`,
  // registration_number: `Registration Number`,
  vendor_company_name: `Company Name`,

  customer_company: `Customer Company`,
  payment_terms: `Payment Terms`,

  buyer_name: `Buyer Name`,
  buyer_manager: `Buyer Manager`,

  service_country: `Service Country`,
  vendor_type: `Vendor Type`,
  vendor_company_address: `Company Address`,
  amos_code: `AMOS Code`,
  service_description: `Service Description`,
  official_document_uploaded: `Official Document`,

  // Entity & Address
  entity_details: `Entity Details`,
  company_type: `Company Type`,
  // tax_type: `Tax Type`,
  // addresst: `Tax Address`,
  // country: `Country`,

  // Contact & Type
  supplier_type: `Goods or Services Provider`,
  contact_name: `Accounting Contact Name`,
  contact_email: `Accounting Contact Email`,
  contact_phone: `Accounting Contact Phone`,

  // Status
  validation_status: `Verification Status`,
  document_validation_status: "Document Validity Status",

  // Banking
  banking_information: `Banking Information`,
  bank_name: `Bank Name`,
  // iban: `IBAN`,
  swift_code: `SWIFT/BIC Code`,
  currencyb: `Bank Account Currency`,

  // Documents
  documents_certificates: `Documents & Certificates`,
  additional_certificate: `Additional Certificates`,
  bank_certificate: `Bank Certificate`,
  tax_residence_certificate: "Tax Residence",

  // optional: `Optional`,

  // Dropdown Values
  Goods: `Goods`,
  Services: `Services`,
  Both: `Both`,
  // Pending: `Pending`,
  favorable: `Favorable`,
  unfavorable: `Unfavorable`,
  current: `Current`,
  IndividualP: "Individual",
  Legal_Entity: "Legal Entity",

  //trigger by
  buyer: "Buyer",
  // supplier: "Supplier",

  // Vendor
  AyudNav: `AyudNav`,
  Call_center: `Call center`,
  Commercial: `Commercial`,
  Consulting: `Consulting`,
  Distribution_cost: `Distribution cost`,
  Employee: `Employee`,
  Fuel: `Fuel`,
  Handling: `Handling`,
  HR: `HR`,
  Incidents: `Incidents`,
  Insurance: `Insurance`,
  Leasing: `Leasing`,
  Legal: `Legal`,
  Maintenance: `Maintenance`,
  Marketing: `Marketing`,
  Navitaire: `Navitaire`,
  Ops: `Ops`,
  Other: `Other`,
  System: `System`,
  Tax: `Tax`,
  Training: `Training`,
  Travel: `Travel`,

  // --- Service Countries ---
  Spain: `Spain`,
  France: `France`,
  Italy: `Italy`,
  Greece: `Greece`,
  "More than one": `More than one`,
  "None of the above": `None of the above`,

  // Bill To
  "Volotea, S.L.": `Volotea, S.L.`,
  "Volotea Flight Academy, S.L.U.": `Volotea Flight Academy, S.L.U.`,

  // Payment Terms
  "0D - Due date invoice date": `0D - Due date invoice date`,
  "30D - Due date 30 days": `30D - Due date 30 days`,
  "45D - Due date 45 days": `45D - Due date 45 days`,
  "60D - Due date 60 days": `60D - Due date 60 days`,

  // --- Validation Messages ---
  Company_Type_is_required: `Company Type is required`,
  Tax_Type_is_required: `Tax Type is required`,
  Name_is_required: `Name is required`,
  Email_must_be_a_valid_email_address: `Email must be a valid email address`,
  Company_ID_is_required: `Registration Number is required`,
  Address_is_required: `Address is required`,
  Country_is_required: `Country is required`,
  Supplier_Type_is_required: `Supplier Type is required`,
  Contact_Name_is_required: `Contact Name is required`,
  Invalid_email: `Invalid email`,
  Contact_Email_is_required: `Contact Email is required`,
  Contact_Phone_is_required: `Contact Phone is required`,
  Bank_Name_is_required: `Bank Name is required`,
  IBAN_is_required: `IBAN is required`,
  IBAN_must_contain_only_numbers: `IBAN must contain only numbers`,
  Currency_is_required: `Currency is required`,
  Additional_Certificate_is_required: `Additional Certificate is required`,
  Bank_Certificate_is_required: `Bank Certificate is required`,
  // Verifactu
  verifactu_document: `Verifactu document`,
  regular_invoice: `Regular invoice`,
  companyEmail: `Company Email`,
  tax_percentage: `Tax percentage`,
  verifactu_regular_invoice: `Regular invoice`,
  verifactu_debit_note: `Debit note`,
  verifactu_credit_note: `Credit note`,
  verifactu_corrective_invoice: `Corrective invoice`,
  verifactu_create_document: `Create verifactu document`,
  comments_max_length: "Comments cannot exceed 500 characters",
  simplified_invoice: `Simplified invoice`,
  RegularInvoice: `Regular invoice`,
  SimplifiedInvoice: `Simplified invoice`,
  ComplianceDetails: "Compliance Details",
  URL: "URL",
  CompliantBy: "Compliant By",
  UpdatedOn: "Updated On",
  CorrectiveInvoice: `Corrective invoice`,
  create_verifactu_document: `Create verifactu document`,
  correctiveInvoice_by_substitution: `Corrective invoice by substitution`,
  correctiveInvoice_by_differences_tooltip: `Adjust only specific lines or amounts`,
  correctiveInvoice_by_substitution_tooltip: `Replace the entire invoice`,
  rectificationReason_is_required: `Rectification reason is required`,
  rectificationReason: `Rectification reason`,
  correctiveInvoice_quantityCorrection: `Quantity correction`,
  correctiveInvoice_priceAdjustment: `Price adjustment`,
  correctiveInvoice_discountApplied: `Discount applied`,
  correctiveInvoice_partialCancellation: `Partial cancellation`,
  correctiveInvoice_fullCancellation: `Full cancellation`,
  upload_creditNote: `Upload credit note`,
  alternate_bank_details: `Alternate bank details`,
  person: `Person`,
  company: `Company`,
  failed_to_fetch_notification: `Failed to fetch notification`,
  new_app_verion_available:
    "Please refresh the page to get the latest version of Dost.",
  update_available: "We've made some improvements",
  refresh: "Refresh",
  preview_and_print: `Preview and print`,
  preview_document: "Preview document",
  powered_sage: "Powered by CONTROL AI SOLUTIONS",
  view_predfined_values: "View Predefined Values",
  field_title: "{{field}}'s values",
  label: "Label",
  tax_fields_are_required: `Tax field(s) are required`,
  item_fields_are_required: `Item field(s) are required`,
  upload_signature: `Upload signature`,
  erp_purchase_order_table: {
    DocumentNo: "Document Number",
    AllocationDate: "Allocation Date",
    No: "No",
  },
  "Verify Your Address Details": "Verify Your Address Details",
  address_details_subtext:
    "Please verify your address details and fill in any missing information.",
  ob_finalize_text: "THANK YOU. YOU WILL BE NOTIFIED ONCE OB IS FINALIZED",
  onboarding_complete: "Onboarding Submitted",
  supplier_not_found: `Supplier not found`,
  drag_and_drop_your_files_here: `Drag and drop your files here`,
  files_accepted_only: `{{acceptedFiles}} files accepted only`,
  browse_files: `Browse files`,
  upload_your_document: `Upload your document`,
  document_name_is_required: `Document name is required`,
  cancel: `Cancel`,
  // Supported Documents
  ...supportedDocuments,
  // duplicate-document-number dialog (existing)
  document_number_already_exists: `Document number already exists`,
  document_number_exists_message: `A document has already been assigned this document number:{{documentNumber}}`,
  would_you_like_to_generate_new_document_number: `Would you like to generate a new document number`,
  regenerate_document_number: `Regenerate document number`,
  document_number_regenerated_successfully: `Document number regenerated successfully`,

  // section headings
  verifactu_simplified_invoice: `Verifactu simplified invoice`,
  sii_simplified_invoice: `SII simplified invoice`,
  sii_regular_invoice: `SII regular invoice`,
  sii_credit_note: `SII credit note`,
  sii_corrective_invoice: `SII corrective invoice`,
  sdi_regular_invoice: `SDI regular invoice`,
  sdi_credit_note: `SDI credit note`,

  // document info fields
  SpainCorrectionCode: `Correction code`,

  // company / contact (shared between customer & vendor)
  Currency: `Currency`,

  // customer address breakdown
  CustomerCompanyStreet: `Company Street`,
  CustomerCompanyStreetNumber: `Company Street Number`,
  CustomerCompanyLocality: `Company Locality`,
  CustomerCompanyRegion: `Company Region`,
  CustomerCompanyZipCode: `Company Zip Code`,
  CustomerCountry: `Country`,
  customerCompanyStreet_is_missing: `Customer company street is missing`,
  customerCompanyStreetNumber_is_missing: `Customer company street number is missing`,
  customerCompanyLocality_is_missing: `Customer company locality is missing`,
  customerCompanyRegion_is_missing: `Customer company region is missing`,
  customerCompanyZipCode_is_missing: `Customer company zip code is missing`,

  // vendor address breakdown
  VendorCompanyStreet: `Company Street`,
  VendorCompanyStreetNumber: `Company Street Number`,
  VendorCompanyLocality: `Company Locality`,
  VendorCompanyRegion: `Company Region`,
  VendorCompanyZipCode: `Company Zip Code`,
  VendorCountry: `Country`,

  // buttons / status
  configuration: `Configuration`,

  // stacked layout (new UI)
  create_compliance_standard_document: `Create {{complianceStandard}} {{documentType}}`,
  customize_invoice_sequencing: `Customize invoice sequencing`,
  configure_document_series: `Configure document series`,
  verifactu: `Verifactu`,
  sdi: `SDI`,
  sii: `SII`,
  logo_url_missing: `Logo URL missing`,
  edit_my_information: `Edit my information`,
  fill_my_details: `Fill in the details to add them to your list`,
  add_logo_url: `Add logo URL`,
  vendor_email_address: `Email address`,
  company_street: `Company street`,
  company_street_number: `Company street number`,
  company_locality: `Company locality`,
  company_zip_code: `Company zip code`,
  company_region: `Company region`,
  po_number: `PO number`,
  add_po_number: `Add PO number`,
  add_delivery_note: `Add delivery note`,
  add_pec_code: `Add PEC code`,
  pec_code: `PEC code`,
  pec_code_is_missing: `PEC code is missing`,
  add_destination_code: `Add destination code`,
  destination_code: `Destination code`,
  destination_code_is_missing: `Destination code is missing`,
  invoice_information: `Invoice information`,
  purchase_order_information: `Purchase order information`,
  delivery_note_information: `Delivery note information`,
  connected_documents: `Connected documents`,
  search_or_add_a_new_customer: `Search or add a new customer`,
  "no_items_added-click_on_add__line_item_to_add_items": `No items added — click on "Add line item" to add items`,
  line_items: `Line items`,
  add_line_item: `Add line item`,
  search_by_reference_code_or_description_or_add_new_item: `Search by reference code or description, or add a new item`,
  search_by_reference_code_description_keywords: `Search by reference code, description, keywords`,
  add_discount: `Add discount`,
  also_add_this_item_to_catalog: `Also add this item to catalog`,
  total_breakdown: `Total breakdown`,
  additional_tax: `Additional tax`,
  support_documents: `Support documents`,
  supporting_documents: `Supporting Documents`,
  discount_type: `Discount type`,
  percentage: `Percentage`,
  base_amount: `Base amount`,
  make_recurring_invoice: `Make recurring invoice`,
  preview_pdf: `Preview PDF`,
  taxes_permission_required: `Taxes permission required`,
  add_new_tax: `Add New Tax`,
  edit_tax: `Edit Tax`,
  rate: `Rate`,
  is_withholding_tax: `Is Withholding Tax`,
  VAT_label: `VAT - Value Added Tax`,
  IGIC_label: `IGIC - Canary Island Tax`,
  IRPF_label: `IRPF - Personal Income Tax`,
  WHT_label: `WHT - Withholding Tax`,
  tax_type_required: `Tax type is required`,
  rate_required: `Rate is required`,
  rate_min: `Rate must be greater than or equal to 0`,
  tax_created_success: `Tax created successfully`,
  tax_updated_success: `Tax updated successfully`,
  error_fetching_tax_data: `Error fetching tax data`,
  update: `Update`,

  // customer edit modal
  edit_customer_information: `Edit customer information`,
  fill_customer_details: `Fill in the customer details to add them to your list`,
  customer_address: `Customer address`,
  customer_company_name: `Customer company name`,
  customer_company_ID: `Customer company ID`,
  customer_email_address: `Customer email address`,
  customerCurrency_is_required: `Customer currency is required`,
  delete_customer_title: `Are you sure you want to remove customer?`,
  delete_customer_warning: `Removing the customer wont delete them but remove them from you invoice`,
  delete_vendor_title: `Are you sure you want to remove vendor?`,
  delete_vendor_warning: `Removing the vendor wont delete them but remove them from your invoice`,
  item_delete_title: `Are you sure you want to delete this item?`,
  item_delete_warning: `Deleting the item will remove it from your invoice`,
  your_information: `(Your Information)`,

  // additional options
  item_level_discount_already_added: `An item-level discount is already applied. Disable item discounts before adding a document-level discount.`,

  // document series modal (new UI)
  customize_invoice_sequencing_number: `Customize invoice sequencing number`,
  sequence_number_sub_text: `Create a new invoice sequencing rule, or view existing & previous sequencing rules`,
  add_new_sequencing_rule: `Add new sequencing rule`,
  add_new_sequence_rule_description: `Adding a new sequence rule replaces the currently active rule`,
  add_new_rule: `Add new rule`,
  starting_number: `Starting number`,
  delete_series: `Delete series?`,
  delete_series_warning: `Deleting this series will remove it from your document`,
  deactive_series: `Deactive series`,
  deactivate: `Deactivate`,
  deactivate_sequence_title: `Deactivate this sequence?`,
  deactivate_sequence_note: `Note: You'll need an active sequence to create new invoices.`,
  add_new: `Add New`,
  add_series_warning: `Adding a new series will replace the active one. Continue?`,
  select_or_type_vendor_company_id: `Select vendor company ID`,
  invoicecompliance_module_not_enabled: `Invoice compliance module is not enabled`,
  please_enter_company_name: "Please enter a company name",
  please_select_company_id: "Please select a company ID",
  please_select_country: "Please select a country",
  please_select_currency: "Please select a currency",
  tax_percentage_is_required: "Tax percentage is required",
  click_to_upload: `Click to upload`,
  additional_options: `Additional options`,
  discount_amount: `Discount amount`,
  no_invoice_number: `No invoice number`,
  vendor_company_ID: `Company ID`,
  wht_tax: `Withholding Tax`,
  reference_code: `Reference code`,
  tax_amount: `Tax (amount)`,
  desigual: {
    profileTitle: "Supplier Profile",
    integrityLinkLabel: "Desigual Integrity",
    profileUpdated: "Profile updated successfully",
    stepSaved: "Progress saved successfully",
    onboardingCompleted: "Onboarding completed successfully",
    autosaving: "Saving",
    autosaved: "Saved",
    back: "Back",
    skip: "Skip",
    save: "Save",
    next: "Next",
    submit: "Submit",
    yes: "Yes",
    no: "No",
    optional: "optional",
    stepSupplierData: "Supplier Data",
    stepAddress: "Address",
    stepContact: "Contact",
    stepBanking: "Banking",
    stepCurrency: "Currency",
    stepPaymentTerms: "Payment Terms",
    stepPaymentMethod: "Payment Method",
    stepDocuments: "Documents",
    supplierName: "Supplier Name",
    taxNumber: "Tax Number",
    entityType: "Entity Type",
    withholdingTax: "Withholding Tax",
    withholdingTaxRate: "Withholding Tax Rate (%)",
    street: "Street",
    streetNumber: "Street Number",
    city: "City",
    regionProvince: "Region / Province",
    postalCode: "Postal Code",
    country: "Country",
    addContact: "Add Contact",
    fullName: "Full Name",
    language: "Language",
    phone: "Phone",
    orderEmail: "Order Email",
    bankName: "Bank Name",
    bankCode: "Bank Code",
    accountNumber: "Account Number",
    checkDigit: "Check Digit",
    iban: "IBAN",
    swiftBic: "SWIFT / BIC",
    intermediaryBank: "Intermediary Bank",
    intermediaryBic: "Intermediary BIC",
    currency: "Currency",
    paymentTerm: "Payment Term",
    paymentTermOther: "Payment Term Description",
    paymentMethod: "Payment Method",
    paymentMethodDirectDebit: "Direct Debit",
    paymentMethodLetterOfCredit: "Letter of Credit",
    paymentMethodConfirming: "Confirming",
    paymentMethodTransfer: "Transfer",
    bankCertificate: "Bank Certificate",
    bankCertDate: "Bank Certificate Issue Date",
    bankCertExpiryDate: "Bank Certificate Expiry Date",
    taxCertificate: "Tax Residence Certificate",
    taxCertIssue: "Tax Certificate Issue Date",
    taxCertExpiryDate: "Tax Certificate Expiry Date",
    bankCertExpiredWarning:
      "⚠️ This bank certificate is more than 1 year old. You can still submit; it will be reviewed manually.",
    taxCertExpiredWarning:
      "⚠️ This tax residence certificate is more than 1 year old. You can still submit; it will be reviewed manually.",
    viewDocCodeOfEthics: "Code of Ethics",
    viewDocTermsAndConditions:
      "General Terms and Conditions of Contracting with Desigual",
    viewDocDataProcessingAgreement: "Personal Data Processing Agreement",
    viewDocument: "View Document",
    whistleblowingTitle: "New Internal Whistleblowing Channel | Integrity Unequal",
    ethicsCode: "I accept Desigual's Code of Ethics",
    ethicsCodeHelper:
      "If you don't accept it, you can upload your own code of ethics instead.",
    ethicsCodeUpload: "Upload Ethics Code Document (optional)",
    whistleblowingBodyBeforeLink:
      "We have enabled Integrity, our internal reporting channel, so you can confidentially and anonymously report any irregular conduct related to our business relationship. You can access it at the following link:",
    whistleblowingBodyAfterLink: "and through our official website,",
    tcApprovalQuestion: "Do you accept the General Terms and Conditions?",
    tcApprovalHelper:
      'If you select "No", upload your signed contract with Desigual as justification.',
    signedContract: "Contract with Desigual",
    validation: {
      supplierName: {
        required: "Supplier name is required",
        max: "Supplier name cannot exceed 35 characters",
      },
      registrationNumber: { required: "Registration number is required" },
      entityType: { required: "Entity type is required" },
      withholdingTax: { required: "Withholding tax selection is required" },
      withholdingTaxRate: {
        required: "Withholding tax rate is required",
        range: "Withholding tax rate must be between 0 and 100",
      },
      street: {
        required: "Street is required",
        max: "Street cannot exceed 35 characters",
      },
      streetNumber: {
        required: "Street number is required",
        max: "Street number cannot exceed 10 characters",
      },
      city: {
        required: "City is required",
        max: "City cannot exceed 25 characters",
      },
      regionProvince: { required: "Region/Province is required" },
      postalCode: {
        required: "Postal code is required",
        max: "Postal code cannot exceed 10 characters",
      },
      country: { required: "Country is required" },
      contacts: { required: "At least one contact is required" },
      fullName: {
        required: "Full name is required",
        max: "Full name cannot exceed 40 characters",
      },
      language: { required: "Language is required" },
      phone: { required: "Phone is required" },
      orderEmail: {
        invalid: "Must be a valid email address",
        required: "Order email is required",
      },
      bankName: {
        required: "Bank name is required",
        max: "Bank name cannot exceed 60 characters",
      },
      bankCode: { required: "Bank code is required" },
      accountNumber: { required: "Account number is required" },
      checkDigit: { required: "Check digit is required" },
      iban: { required: "IBAN is required" },
      swiftBic: { required: "SWIFT / BIC is required" },
      currency: { required: "Currency is required" },
      paymentTerm: { required: "Payment term is required" },
      paymentTermOther: { required: "Payment term description is required" },
      paymentMethod: { required: "Payment method is required" },
      bankCertificate: { required: "Bank certificate is required" },
      bankCertDate: { required: "Bank certificate issue date is required" },
      taxCertificate: { required: "Tax residence certificate is required" },
      taxCertIssue: { required: "Tax certificate issue date is required" },
      tcApproval: { required: "Please select Yes or No" },
      signedContract: {
        required: "Please upload your signed contract with Desigual",
      },
    },
  },
};

export default en;
